import React from "react";
//#region redux
import { useSelector, useDispatch } from "react-redux";
import { AppState } from "store";
import { ThunkDispatch } from "redux-thunk";
import { setFullScreenDialogOpen } from "store/actions/utilActions";
//#endregion
//#region types
//#endregion
//#region components
import { Grid } from "@mui/material";
import SupportSpeedDial from "components/support/supportSpeedDial";
import { SpeedDial } from "components/layout";
import { useLocation } from "react-router-dom";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const SpeedDialContainer: React.FC = (props) => {
  const isFullScreenDialogOpen = useSelector((store: AppState) => store.util.isFullScreenDialogOpen);
  const hideSpeedDials = useSelector((store: AppState) => store.util.dialogQueue).some(
    (dialog) => dialog.hideSpeedDials
  );
  const isDialogOpen = useSelector((store: AppState) => store.util.isDialogOpen);
  const isFilterDrawerOpen = useSelector((store: AppState) => store.util.isFilterDrawerOpen);
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  const location = useLocation();

  React.useEffect(() => {
    if (isFullScreenDialogOpen && isFullScreenDialogOpen.isOpen) {
      dispatch(setFullScreenDialogOpen(false));
    }
  }, [location]);

  const isSupportSpeedDialVisible =
    !hideSpeedDials &&
    !isFilterDrawerOpen &&
    (!isFullScreenDialogOpen?.isOpen || (isFullScreenDialogOpen?.isOpen && isFullScreenDialogOpen.type !== "wizard"));
  const isSubmitSpeedDialVisible =
    !hideSpeedDials && !isFilterDrawerOpen && !isFullScreenDialogOpen?.isOpen && !isDialogOpen;

  return (
    <Grid
      container
      item
      xs="auto"
      direction="row"
      columnGap={2}
      className={cssExports.speedDialContainerOuter}
      justifyContent="flex-end"
    >
      {isSupportSpeedDialVisible ? (
        <Grid item>
          <SupportSpeedDial />
        </Grid>
      ) : (
        <></>
      )}
      {isSubmitSpeedDialVisible ? (
        <Grid item>
          <SpeedDial />
        </Grid>
      ) : (
        <></>
      )}
    </Grid>
  );
};

export default SpeedDialContainer;
